import {Testbed} from "./testbed";
import {Box} from "./box";


export class PatchContract {

  id?: number;
  extendedEndDate?: Date;
  status?: string;
  accepted?: boolean;

  testbed?: Testbed;
  boxes?: Box[];

}
